import { render, staticRenderFns } from "./ProjectsComponent.vue?vue&type=template&id=49ab6190&scoped=true&"
import script from "./ProjectsComponent.vue?vue&type=script&lang=js&"
export * from "./ProjectsComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsComponent.vue?vue&type=style&index=0&id=49ab6190&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ab6190",
  null
  
)

export default component.exports